import { navigateToUrl } from "single-spa";

/**
 * @description Determina si la ruta es la ruta del cliente o usuario
 * @returns {string} "clients" | "users"
 */
export function isLocalHost() {
  return globalThis.location.hostname === "localhost";
}

/**
 * @description traido manualmente mientras se prueba la importación del portalcash-shared
 */
export function clientPath(hostname) {
  if (hostname.includes("credicorpcapitaldigital.ccnoprod.com")) {
    return "/portalcash/chl/corecashchile-clients";
  }
  return "/corecashchile-clients";
}

/**
 * @description traido manualmente mientras se prueba la importación del portalcash-shared
 */
export function usersPath(hostname) {
  if (hostname.includes("credicorpcapitaldigital.ccnoprod.com")) {
    return "/portalcash/chl/corecashchile-users";
  }
  return "/corecashchile-users";
}

/**
 * @description Determina si la ruta es la ruta del cliente o usuario
 * @returns {string} "clients" | "users"
 */
export function isClientOrUser() {
  const onLocal = localStorage.getItem("initial_path");

  const _VALIDATORS_ = {
    clientsOnLocal: onLocal?.includes("clients"),
    usersOnLocal: onLocal?.includes("users"),
    clientsOnPath: globalThis.location.pathname.includes("clients"),
    usersOnPath: globalThis.location.pathname.includes("users"),
  };

  if (_VALIDATORS_.clientsOnLocal) {
    return "clients";
  }
  if (_VALIDATORS_.usersOnLocal) {
    return "users";
  }

  if (_VALIDATORS_.clientsOnPath) {
    return "clients";
  }
  if (_VALIDATORS_.usersOnPath) {
    return "users";
  }

  return "clients";
}

function redirectIfClientNotExists(hostname) {
  const user = localStorage.getItem("user");
  const clientId = localStorage.getItem("clientId");
  const client = localStorage.getItem("client");

  if (
    !clientId &&
    !client &&
    user &&
    !globalThis.location.pathname.includes(`${clientPath(hostname)}/my-company`)
  ) {
    navigateToUrl(`${clientPath(hostname)}/my-company`);
  }
}

/**
 * @description Inicializa la redirección de rutas
 */
export function initRedirect() {
  const hostname = globalThis.location.hostname;

  if (globalThis.location.pathname.includes("clients")) {
    localStorage.setItem("initial_path", "/corecashchile-clients");
    redirectIfClientNotExists(hostname);
  }

  if (globalThis.location.pathname.includes("users")) {
    localStorage.setItem("initial_path", "/corecashchile-users");
  }

  /**
   * @description Redirige a la ruta de login del cliente o usuario si la ruta es la ruta raíz
   */
  if (
    globalThis.location.pathname === "/" ||
    globalThis.location.pathname === "/portalcash/chl/"
  ) {
    if (isClientOrUser() === "clients") {
      // En producción, redirigir a CoreCash-Widget-Login
      navigateToUrl(`${clientPath(hostname)}/login`);
    } else {
      // En desarrollo, redirigir a ruta de login según layout
      navigateToUrl(`${usersPath(hostname)}/auth/login`);
    }
  }

  /**
   * @description Redirige a la ruta de login del cliente si la ruta es la ruta del cliente
   */
  if (globalThis.location.pathname === clientPath(hostname)) {
    navigateToUrl(`${clientPath(hostname)}/login`);
  }
  /**
   * @description Redirige a la ruta de login del usuario si la ruta es la ruta del usuario
   */
  if (globalThis.location.pathname === usersPath(hostname)) {
    navigateToUrl(`${usersPath(hostname)}/auth/login`);
  }

  /**
   * @description Redirige a la ruta de login del usuario si la ruta es la ruta del usuario con /login
   */
  if (globalThis.location.pathname === `${usersPath(hostname)}/login`) {
    navigateToUrl(`${usersPath(hostname)}/auth/login`);
  }
}
